import { render, staticRenderFns } from "./BadRequest.vue?vue&type=template&id=580917c7&scoped=true"
import script from "./BadRequest.vue?vue&type=script&lang=js"
export * from "./BadRequest.vue?vue&type=script&lang=js"
import style0 from "./BadRequest.vue?vue&type=style&index=0&id=580917c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580917c7",
  null
  
)

export default component.exports